<template lang="pug">
    page(:centered="false"
        :delegated-loading="true"
        :loading="loading"
        v-if="riskAssessmentLoaded")

        template(#title="") {{$t(`pages.list.${name}.title`)}}

        template(#content-template="" v-if="!loading")
            v-container
                v-layout(wrap)
                    v-flex(xs12)
                        m-block-page-assessment-object-info(v-if="!$lodash.isEmpty(raObject)" :item="raObject")
                            template(#title="") {{$t(`pages.list.${name}.info`, {name: raObject.name})}}

            m-block-questions(
                v-if="!$lodash.isEmpty(temporaryAssessment)"
                :item="section" :answers="answers"
                :isOnce="isOnce"
                :entryPoint="entryPoint"
                :needConfirmRedirect.sync="needConfirmRedirect"
                :raId="riskAssessment._id"
                :isOnboarding="isOnboarding")
</template>

<script>
    import MBlockPageAssessmentObjectInfo
        from "@modules/blocks/page/concrete/m-block-page-assessment-object-info";
    import MBlockQuestions from "@modules/blocks/content/risk-assessment/m-block-questions";
    import {mapGetters, mapActions} from 'vuex';
    import errorHandler from "@mixins/responses/_errorHandler";
    import notifications from "@mixins/includes/_notifications";
    import basePage from "@mixins/components/pages/base";
    import dialogs from "@mixins/includes/_dialogs";

    let name = 'risk-assessment-process';
    export default {
        name: name,
        mixins: [basePage, errorHandler, notifications, dialogs],
        components: {MBlockQuestions, MBlockPageAssessmentObjectInfo},
        props: {
            name: {
                type: String,
                default: name
            },
            meta: {
                type: Object,
                default: () => ({
                    title: `pages.list.${name}.meta.title`
                })
            },
            isOnboarding: {
                type: Boolean,
                default: false
            }
        },
        data:() => ({
            isOnce: false,
            // this prop indicates which level the process started from (if the process started for a separate branch in config section, not for whole section)
            entryPoint: null,
            temporaryAssessment:{},
            needConfirmRedirect: false
        }),
        async created() {

            if(!this.$route.query.level) {
                    this.redirect(this.redirectProcess(), {
                        id: this.$route.params.id
                    }, {
                        level: '0-0'
                    });
            } else if (this.$route.query.level.length < 3) {
                    this.redirect(this.redirectProcess(), {
                        id: this.$route.params.id
                    }, {
                        level: this.$route.query.level + '-0'
                    });
            } else {
                this.isOnce = true;
                this.entryPoint = this.$route.query.level;
                try {
                    await this.requestRiskAssessments({id: this.$route.params.id});
                    await this.requestRaObject({id: this.riskAssessment._jv.relationships.objects.data.id});
                    await this.requestRaObjectType({id: this.raObject._jv.relationships.objectType.data.id});
                    this.$iBreadcrumbs.setParentText(this.riskAssessment.metadata.name);
                } catch (e) {
                    if (e.response && e.response.status === 404) {
                        // TODO define server side error
                        this.notify.error(this.$t('notifications.errors.loseRightsOnRa'))
                        this.needConfirmRedirect = false
                        this.redirect(this.redirectIndex());
                    } else {
                        this.error.handle(e)
                    }
                }
                this.needConfirmRedirect = true
            }

            this.temporaryAssessment = this.riskAssessment;
        },
        async beforeRouteLeave (to, from, next) {
            if(to.name === this.nav.dashboard.service.risk_assessment.view.name || !this.needConfirmRedirect || this.$lodash.isEmpty(this.$user)) {
                return next()
            }
            let confirmed = await this.openDialog('cancelAssessment');
            if (!confirmed) return;
            this.needConfirmRedirect = false
            return next()
        },
        computed: {
            ...mapGetters({
                getRiskAssessment: 'riskAssessments/read',
                getRaObject: 'objects/read',
            }),
            loading(){
                return this.$wait.waiting([this.keys.riskAssessments.read, this.keys.objects.read, this.keys.objectTypes.read])
            },
            section() {
                return this.configuration[this.parseQuery(this.$route.query.level)[0]];
            },
            riskAssessment() {
                return Object.assign({},this.getRiskAssessment(this.$route.params.id));
            },
            riskAssessmentLoaded() {
                return Object.keys(this.riskAssessment).length > 0
            },
            configuration(){
                return this.temporaryAssessment.config
            },
            answers(){
                return this.riskAssessment.configWithAnswer
            },
            raObject() {
                return this.getRaObject(this.$getId(this.riskAssessment._jv.relationships.objects.data.id));
            }
        },
        methods: {
            ...mapActions({
                requestRiskAssessments: 'riskAssessments/read',
                requestRaObject:'objects/read',
                requestRaObjectType:'objectTypes/read'
            }),
            redirectProcess(){
                if(this.isOnboarding){
                    return this.nav.dashboard.service.onboarding_risk_assessment.process.name
                }else{
                    return this.nav.dashboard.service.risk_assessment.process.name
                }
            },
            redirectIndex(){
                if(this.isOnboarding){
                    return this.nav.dashboard.service.onboarding_risk_assessment.index.name
                }else{
                    return this.nav.dashboard.service.risk_assessment.index.name
                }
            },
            parseQuery(q) {
                return q.split('-')
            }
        }
    }
</script>

<style lang="scss" scoped>
    //
</style>
